"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistStepT = exports.TrackingChecklistStep = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracking_checklist_extra_data_js_1 = require("../../solarxr-protocol/rpc/tracking-checklist-extra-data.js");
const tracking_checklist_step_id_js_1 = require("../../solarxr-protocol/rpc/tracking-checklist-step-id.js");
const tracking_checklist_step_visibility_js_1 = require("../../solarxr-protocol/rpc/tracking-checklist-step-visibility.js");
class TrackingChecklistStep {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistStep(bb, obj) {
        return (obj || new TrackingChecklistStep()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistStep(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistStep()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN;
    }
    valid() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    enabled() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    visibility() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracking_checklist_step_visibility_js_1.TrackingChecklistStepVisibility.ALWAYS;
    }
    optional() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    ignorable() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    extraDataType() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : tracking_checklist_extra_data_js_1.TrackingChecklistExtraData.NONE;
    }
    extraData(obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__union(obj, this.bb_pos + offset) : null;
    }
    static startTrackingChecklistStep(builder) {
        builder.startObject(8);
    }
    static addId(builder, id) {
        builder.addFieldInt8(0, id, tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN);
    }
    static addValid(builder, valid) {
        builder.addFieldInt8(1, +valid, +false);
    }
    static addEnabled(builder, enabled) {
        builder.addFieldInt8(2, +enabled, +false);
    }
    static addVisibility(builder, visibility) {
        builder.addFieldInt8(3, visibility, tracking_checklist_step_visibility_js_1.TrackingChecklistStepVisibility.ALWAYS);
    }
    static addOptional(builder, optional) {
        builder.addFieldInt8(4, +optional, +false);
    }
    static addIgnorable(builder, ignorable) {
        builder.addFieldInt8(5, +ignorable, +false);
    }
    static addExtraDataType(builder, extraDataType) {
        builder.addFieldInt8(6, extraDataType, tracking_checklist_extra_data_js_1.TrackingChecklistExtraData.NONE);
    }
    static addExtraData(builder, extraDataOffset) {
        builder.addFieldOffset(7, extraDataOffset, 0);
    }
    static endTrackingChecklistStep(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistStep(builder, id, valid, enabled, visibility, optional, ignorable, extraDataType, extraDataOffset) {
        TrackingChecklistStep.startTrackingChecklistStep(builder);
        TrackingChecklistStep.addId(builder, id);
        TrackingChecklistStep.addValid(builder, valid);
        TrackingChecklistStep.addEnabled(builder, enabled);
        TrackingChecklistStep.addVisibility(builder, visibility);
        TrackingChecklistStep.addOptional(builder, optional);
        TrackingChecklistStep.addIgnorable(builder, ignorable);
        TrackingChecklistStep.addExtraDataType(builder, extraDataType);
        TrackingChecklistStep.addExtraData(builder, extraDataOffset);
        return TrackingChecklistStep.endTrackingChecklistStep(builder);
    }
    unpack() {
        return new TrackingChecklistStepT(this.id(), this.valid(), this.enabled(), this.visibility(), this.optional(), this.ignorable(), this.extraDataType(), (() => {
            const temp = (0, tracking_checklist_extra_data_js_1.unionToTrackingChecklistExtraData)(this.extraDataType(), this.extraData.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })());
    }
    unpackTo(_o) {
        _o.id = this.id();
        _o.valid = this.valid();
        _o.enabled = this.enabled();
        _o.visibility = this.visibility();
        _o.optional = this.optional();
        _o.ignorable = this.ignorable();
        _o.extraDataType = this.extraDataType();
        _o.extraData = (() => {
            const temp = (0, tracking_checklist_extra_data_js_1.unionToTrackingChecklistExtraData)(this.extraDataType(), this.extraData.bind(this));
            if (temp === null) {
                return null;
            }
            return temp.unpack();
        })();
    }
}
exports.TrackingChecklistStep = TrackingChecklistStep;
class TrackingChecklistStepT {
    constructor(id = tracking_checklist_step_id_js_1.TrackingChecklistStepId.UNKNOWN, valid = false, enabled = false, visibility = tracking_checklist_step_visibility_js_1.TrackingChecklistStepVisibility.ALWAYS, optional = false, ignorable = false, extraDataType = tracking_checklist_extra_data_js_1.TrackingChecklistExtraData.NONE, extraData = null) {
        this.id = id;
        this.valid = valid;
        this.enabled = enabled;
        this.visibility = visibility;
        this.optional = optional;
        this.ignorable = ignorable;
        this.extraDataType = extraDataType;
        this.extraData = extraData;
    }
    pack(builder) {
        const extraData = builder.createObjectOffset(this.extraData);
        return TrackingChecklistStep.createTrackingChecklistStep(builder, this.id, this.valid, this.enabled, this.visibility, this.optional, this.ignorable, this.extraDataType, extraData);
    }
}
exports.TrackingChecklistStepT = TrackingChecklistStepT;
